export default {
  en: {
    banner: {
      title: 'Vote for the next project to be listed on Binance.com!',
      desc: 'Binance Community Vote: Round @1',
      status2: 'Voting will start in:',
      status3: 'Voting will end in：',
      status4: 'The vote has ended. Thank you for your participation!',
      countDown: {
        D: 'Days', H: 'Hours', M: 'Minutes', S: 'Seconds',
      },
    },
    result: {
      title: 'Winner Rewards',
      rule: 'Detailed Rules >',
      profitTitle: 'Winners will share',
      profitExt: 'Vote for @1 and if they win, also share',
      success: 'Congratulations! You have won the following rewards for voting:',
      fail: 'Bad luck! You did not win any rewards this time.',
    },
    content: {
      preTips: 'I currently have: Login to check. ',
      tips: 'I currently have:',
      goLogin: 'Login now >',
      unit: 'Vote(s)',
      myRecord: 'My voting records >',
      voteBtn: 'Vote for @1',
      mySelected: '( My Selection )',
    },
    moreBtn: 'More project details >',
    table1: {
      title: 'Calculation for number of votes',
      trList: ['Average daily BNB holdings', 'Number of votes'],
    },
    table2: {
      title: 'BNB holding details',
      extTipAvg: 'Current daily average BNB holdings:',
      extTipPre: 'Historical balances >',
      trList: ['Date', 'BNB holding amount'],
      preLogin: 'Login to check.',
      goLogin: 'Login now >',
    },
    term: {
      title: 'Terms & conditions:',
      content: `
      The winner of this vote will receive a free listing on Binance.com.#
      We will endeavor to list the winning project’s token within a reasonable time frame after the vote, pending wallet and tech integration for the coin. #
      Users will only be able to choose one project to contribute all their votes to. You cannot vote for both projects.#
      Binance reserves all rights to change the rules of this event without notification, including the revoking the results suspected of vote manipulation.#
      Rewards will be issued within 2 weeks after the vote ends.
      `,
    },
    toast: { success: '投票成功' },
    confirm: {
      cancel: 'Cancel',
      goVoteTitle: 'Vote Confirmation',
      goVoteMessage: 'You are voting for @1 and only have one chance to vote. Are you sure you want to proceed?',
      goVoteDesc: 'Your number of votes: @1 vote(s)',
      goVoteCharge: 'Voting fee: @1@2',
      goVoteOk: 'Confirm Vote',
      kycTitle: 'Identity Verification',
      kycOk: 'Verify Now',
      othersTitle: 'You are not eligible to participate in this vote',
      othersOK: 'I understand',
    },
    share: {
      message: 'Feeling lucky? Share your vote and follow Binance for an extra chance to win!',
      shareInfoWb: '在本期币安社区投票上币PK赛中，我投给了@@1资讯 #投票支持@1# 点击投票',
      shareInfoTw: '🗳I voted for @@1 to be listed on Binance.com in the @Binance Community Vote! #Vote @1# Cast your vote here',
    },
  },
  cn: {
    banner: {
      title: '为您支持的币种投票上币',
      desc: '币安第@1期投票上币',
      status2: '距投票开始还有:',
      status3: '距投票结束还有:',
      status4: '投票已结束,感谢关注',
      countDown: {
        D: '天', H: '时', M: '分', S: '秒',
      },
    },
    result: {
      title: '获胜奖励',
      rule: '详细规则>',
      profitTitle: '获胜可瓜分',
      profitExt: '支持@1并获胜，可瓜分',
      success: '恭喜,本期投票你获得:',
      fail: '很遗憾,本期投票您没有获得奖励',
    },
    content: {
      preTips: '我的可投票数:登录后查看',
      tips: '我的可投票数:',
      goLogin: '去登录 >',
      unit: '票',
      myRecord: '我的投票记录 >',
      voteBtn: '我支持@1',
      mySelected: '(我的选择)',
    },
    moreBtn: '查看更多>',
    table1: {
      title: '持仓票数计算规则',
      trList: ['BNB日平均持仓', '可投票权'],
    },
    table2: {
      title: '活动持仓详情',
      extTipAvg: '平均日持仓',
      extTipPre: '历史持仓 >',
      trList: ['日期', '当日BNB持仓'],
      preLogin: '登录后查看，',
      goLogin: '去登录 >',
    },
    term: {
      title: '规则内容',
      content: `
        投票获胜方将免费上市Binance.com；#
        Binance将在投票结束后，尽快安排与获胜项目的钱包、技术对接，以期尽快上市交易;# 
        用户只能投票给1个项目。#
        Binance保留对活动的最终解释权，包括对刷票行为的处理。#
        空投奖励将在活动结束后的2周内分发。
      `,
    },
    toast: { success: '投票成功' },
    confirm: {
      cancel: '取消',
      goVoteTitle: '投票确认',
      goVoteMessage: '您将为X币投票,一经投出不可更改,确认投票么?',
      goVoteDesc: '您将投出:@1票',
      goVoteCharge: '手续费:@1@2',
      goVoteOk: '确认投票',
      kycTitle: '身份认证',
      kycOk: '去认证',
      othersTitle: '暂时不能参与活动',
      othersOK: '我知道了',
    },
    share: {
      message: '分享你的投票结果，更多惊喜在等你！',
      shareInfoWb: '在本期币安社区投票上币PK赛中，我投给了@@1资讯 #投票支持@1# 点击投票',
      shareInfoTw: 'I voted for @@1 to be listed on Binance.com in the @Binance Community Vote! #Vote @1# Cast your vote here',
    },
  },
};
